import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';

export const useCancelAiSummary = () => {
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError, string>(
    async jobId => {
      await Axios.delete(DELETE_URL(jobId).cancelAiSummary);
    },
    {
      onSuccess: (_, jobId) => {
        queryClient.invalidateQueries(['aiSummaryJob', jobId]);
      }
    }
  );
};
